export default __webpack_public_path__ + "static/media/guia-escritorio-1.7872a1a7.png";